import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonList,
  IonRow,
  IonTitle,
  IonToggle,
  IonToolbar,
  LoadingController,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FreightCarrierStoreService } from '../freight-carrier-store.service';

@Component({
  selector: 'lib-freight-carrier-finished-search-modal',
  templateUrl: './freight-carrier-finished-search-modal.component.html',
  styleUrls: ['./freight-carrier-finished-search-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IonList,
    IonToggle,
    ReactiveFormsModule,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonIcon,
    IonContent,
    IonFooter,
    IonItem,
    IonGrid,
    IonRow,
    IonCol,
    TranslateModule,
  ],
})
export class FreightCarrierFinishedSearchModalComponent {
  private readonly fb = inject(FormBuilder);
  private readonly modalCtrl = inject(ModalController);
  private readonly loadingCtrl = inject(LoadingController);
  private readonly translate = inject(TranslateService);
  private readonly freightCarrierStoreService = inject(FreightCarrierStoreService);

  public searchForm: FormGroup;

  constructor() {
    // Reflects the currently applied filters so the form shows the active search state.
    const current = this.freightCarrierStoreService.activeFinishedFilters();

    this.searchForm = this.fb.group({
      withoutDigitizedDeliveryNotes: [current?.withoutDigitizedDeliveryNotes ?? false],
      pendingPaperDeliveryNote: [current?.pendingPaperDeliveryNote ?? false],
    });
  }

  public async confirm(): Promise<boolean> {
    const loading = await this.loadingCtrl.create({
      message: this.translate.instant('general.send_data'),
    });
    loading.present();

    const withoutDocs = this.searchForm.get('withoutDigitizedDeliveryNotes')?.value;
    const pendingPaper = this.searchForm.get('pendingPaperDeliveryNote')?.value;

    this.freightCarrierStoreService.applyFinishedFilters(
      withoutDocs || pendingPaper
        ? {
            ...(withoutDocs ? { withoutDigitizedDeliveryNotes: true } : {}),
            ...(pendingPaper ? { pendingPaperDeliveryNote: true } : {}),
          }
        : null,
    );

    await loading.dismiss();
    return this.modalCtrl.dismiss(null, 'confirm');
  }

  public cancel(): Promise<boolean> {
    return this.modalCtrl.dismiss(null, 'cancel');
  }
}
